export const useHasInitProfile = () => useState('has-init-profile', () => false);
